
    <a [routerLink]="['/sala-de-prensa',prensaBlock_item.id]">
         <div class="col-lg-12 sala-prensa-blq-inner-img">
             <img [src]='img' class="img-full-cover" alt="{{prensaBlock_item.imageSalaAlt}}"/>
                    
                         <div class="prensa-showcase__footer">
                         
                                 <div class="text">
                                   <p class="fw-bold" [innerHTML]="prensaBlock_item.titleSala"></p>
                                   <span>{{fecha}}</span>
                              </div>

                              <div class="forma">
                                  <div class="forma-blq"></div>
                              </div>
                     
                            </div>
                </div>
    </a>
